<script lang="ts">
    
    import type { State } from "../../Model/State";

    export let state: State = undefined;
    export let not = false;

    $: truthy = state ? !!$state : false;

</script>

{#if not ? !truthy : truthy}
    <slot />
{/if}
